const initialState = {
    isOpen: false,
    message: ''
}

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_LOADER':
            return {
                isOpen: true,
                message: action.payload || ''
            }
        case 'HIDE_LOADER':
            return {
                isOpen: false,
                message: ''
            }
        default:
            return state
    }
}
